import { SettingOutlined } from "@ant-design/icons";
import { Tabs } from "antd";
import { useState } from "react";
import TbGroup from "../../../../components/MagaTableV2/tbgroup";
import VehicleInformationyTabs from "../VehicleInformationyTabs";

const UsedCar = ({ stData = {} as any, stChange = (data: any) => { } }) => {
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.ownership_type?.list.map((col: any) => {
      if (col.field === 'vehicle_model' || col.field === 'vehicle_brand') return;
      if (col.field === 'cus_name') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          cellRenderer: (params: any) => {
            return (
              <div className={params.data.cus_name_id !== 'Không xác định' && params.data.cus_name_id ? 'cus-link-detail' : ''}>
                <a className="color-bage d-none" href={`/customer/pooling-data/customer-list/detail?id_sync=${params.data.cus_name_id}`}>{params.data.cus_name}</a>
                <span className="text">{params.data.cus_name || 'Không xác định'}</span>
              </div>
            )
          },
        });
      } else {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
        })
      }
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheUsedCar',
    col: [
      {
        field: "vehicle_model",
        headerName: "Hành động",
        width: 300,
        filter: false,
        lockPosition: 'left',
      },
      ...tableColumns(stData.sourceColumnWarehouse),
      // {
      //   field: "vehicle_name",
      //   headerName: "Tên xe",
      // },
      // {
      //   field: "dongxe",
      //   headerName: "Dòng xe",
      // },
      // { field: "cus_name", headerName: "Chủ sở hữu" },
      // { field: "box_code", headerName: "Thùng" },
      // { field: "chassis_no", headerName: "Số khung (VIN)" },
      // { field: "number_plate", headerName: "Biển số xe" },
      // { field: "color_name", headerName: "Màu xe" },
      // { field: "branch_name", headerName: "Đơn vị dùng dịch vụ" },
      // { field: "latest_service_date", headerName: "own_last_repair_date" },
    ],
    listData: stData.xesudung || [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
    defaultColDef: { sortable: false },
    treeField: ["vehicle_brand", "vehicle_model"],
    height: '400px',
  });
  const [activeServiceRecordsTab, setActiveServiceRecordsTab] = useState("1");
  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <TbGroup stData={{ ...megaTableData }} stChange={(data, type) => {
        if (type === 'viewDetail') {
          stChange({ xesudung_show: data });
        }
        if (type === 'showSetting') {
          setMegaTableData((prev: any) => ({ ...prev, showSetting: data }));
        }
      }} />
      <div
        className="ag-theme-alpine custom-table-ag custom-page-css custom-tabs"
        style={{ width: "100%", marginTop: "16px" }}
      >
        <Tabs
          activeKey={activeServiceRecordsTab}
          items={[
            {
              key: "1",
              label: (
                <span className="custom-page-css font-light text-lg">Thông tin xe</span>
              ),
              children: (
                <VehicleInformationyTabs stData={stData} />
              ),
            }
          ]}
          onChange={(k) => setActiveServiceRecordsTab(k)}
        />
      </div>
    </>
  );
};
export default UsedCar;
